<prlw-common-pane [appearance]="appearance">
  @if (items) {
    <div class="marquee-container" #marqueeContainer>
      <div class="marquee-content" #marqueeContent>
        <ng-template #marqueeLinks>
          @for (item of items; track $index) {
            <a
              class="marquee-item prevent-select"
              [href]="item.url"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span class="bullet" aria-hidden="true"></span>
              @if (item.source) {
                <span class="source-icon" aria-hidden="true">
                  @switch (item.source) {
                    @case ('rss') {
                      <img
                        src="assets/logo/social-network/rss.svg"
                        alt="RSS-ленты новостных агентств"
                        title="RSS-ленты новостных агентств"
                      />
                    }
                    @case ('brave') {
                      <span title="Brave Search API">🔍</span>
                    }
                    @case ('telegram') {
                      <img
                        src="assets/logo/social-network/telegram.svg"
                        alt="Telegram-каналы"
                        title="Telegram-каналы"
                      />
                    }
                    @case ('report') {
                      <span title="Отчёты (АТР и др.)">📊</span>
                    }
                    @case ('decompose') {
                      <span title="Извлечён из статьи-подборки (декомпозиция)"
                        >🧩</span
                      >
                    }
                    @case ('manual_input') {
                      <span title="Ручная подача ссылки пользователем">✍️</span>
                    }
                    @default {
                      <span [attr.title]="item.source">🔗</span>
                    }
                  }
                </span>
              }
              <span class="marquee-text" [attr.title]="item.title">
                @if (item.dateLabel) {
                  <span class="marquee-date">{{ item.dateLabel }}</span>
                }
                <span class="marquee-title">{{ truncate(item.title) }}</span>
              </span>
            </a>
          }
        </ng-template>
        <ng-container [ngTemplateOutlet]="marqueeLinks" />
        <ng-container [ngTemplateOutlet]="marqueeLinks" />
      </div>
    </div>
  }
</prlw-common-pane>
